/**
 * 瓦斯帳戶點數。兩種點數都掛在「瓦斯行帳戶」（context）底下、由該瓦斯行發放與認列，
 * 不是平台通用點數 —— 換一家瓦斯行就是另一份餘額。
 *
 * - 存氣點數（stored_gas）：退桶時桶內沒用完的氣，折算後存回帳戶。屬於「氣」，只能折瓦斯品項。
 * - 帳戶點數（account）：溢繳、儲值留在瓦斯行的錢。屬於「錢」，可折整張訂單。
 */
export type PointsKind = "stored_gas" | "account";

export interface PointsBalance {
  /** 存氣點數餘額（點） */
  storedGas: number;
  /** 帳戶點數餘額（點） */
  account: number;
}

/** 點數異動一筆。amount 正 = 入帳，負 = 折抵/扣除。 */
export interface PointsTxn {
  id: string;
  kind: PointsKind;
  amount: number;
  /** 該筆之後的同類點數餘額 */
  balanceAfter: number;
  /** 異動事由，例：「退桶剩餘氣折算」「訂單折抵」 */
  title: string;
  /** 關聯單號等補充說明 */
  note?: string;
  /** ISO 字串 */
  created_at: string;
}

export interface PointsSummary {
  context_id: string;
  balance: PointsBalance;
  txns: PointsTxn[];
}

export const POINTS_KIND_LABEL: Record<PointsKind, string> = {
  stored_gas: "存氣點數",
  account: "帳戶點數",
};
